import { gql } from '@apollo/client';

export const DEBOUNCE_TIME = 700;

export const ORDER_COMPANIES_BY = 'name ASC';
export const COMPANIES_LIMIT = 50;

export const GET_ALL_COMPANIES = gql`
  query Companies($limit: Int!, $offset: Int!, $order: String!, $search: String) {
    companies(limit: $limit, offset: $offset, order: $order, search: $search) {
      id
      name
    }
  }
`;

export const GET_ALL_PRICES = gql`
  query AllCompanyPrices($companyId: ID) {
    allCompanyPrices(companyId: $companyId) {
      id
      productType
      price
      company {
        id
        name
      }
    }
  }
`;

export const CHANGE_PRICE = gql`
  mutation ChangePrice($productType: String!, $price: Float!, $companyId: ID) {
    changePrice(productType: $productType, price: $price, companyId: $companyId) {
      price {
        id
        productType
        price
        company {
          id
          name
        }
      }
    }
  }
`;

export const DELETE_PRICE = gql`
  mutation DeletePrice($productType: String!, $companyId: ID!) {
    deletePrice(productType: $productType, companyId: $companyId) {
      price {
        id
        deleted
      }
    }
  }
`;

export const SET_COMPANY_FEATURE_FLAG = gql`
  mutation UpdateFeatureFlagForCompany ($companyId: ID!, $featureFlagId: ID!, $enabled: Boolean!) {
    updateFeatureFlagForCompany (companyId: $companyId, featureFlagId: $featureFlagId, enabled: $enabled) {
      companyFeatureFlag {
        company {
          id
          name
        }
        featureFlag {
          id
          name
        }
        enabled
      }
    }
  }
`;

export const SET_GLOBAL_FEATURE_FLAG = gql`
  mutation UpdateFeatureFlagForAllCompanies ($featureFlagId: ID!, $enabled: Boolean!) {
    updateFeatureFlagForAllCompanies (featureFlagId: $featureFlagId, enabled: $enabled) {
      featureFlag {
        id
        name
      }
    }
  }
`;

export const GET_COMPANY_BY_ID = gql`
  query Company($id: ID!) {
    company(id: $id) {
      id
      name
      uploadResearchTotalStorage
      uploadResearchConsumedStorage
      uploadResearchAvailableStorage
    }
  }
`;

export const ADD_STORAGE = gql`
  mutation AdminAddStorage($companyId: ID!, $storageAmount: Int!) {
    adminAddStorage(companyId: $companyId, storageAmount: $storageAmount) {
      company {
        id
        uploadResearchTotalStorage
      }
    }
  }
`;
